import { Component, Inject, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { JApiService} from '@j/api';
import { LanguageService } from '@hio/language';
import { JcRaisedButtonDirective } from '@jc/button';
import { ensureShareBasicI18n } from './share-basic-i18n';

@Component({
    selector: 'dialog-delete',
    styles: [
        `

        `
    ],
    template: `
<div>
    <h2 mat-dialog-title> {{ title }}

    </h2>
    <hr>
    <mat-dialog-content style="display: flex; white-space: pre-line;">
      {{ text }}
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions>
      <div class="spacer"></div>
            <button color="primary" jcRaisedButton (click)="onCancel()">{{ lang.t('shareBasic.close') }}</button>
    </mat-dialog-actions>
</div>
    `,
        changeDetection: ChangeDetectionStrategy.Eager,
        imports: [MatDialogModule, JcRaisedButtonDirective]
})

export class DialogInfoComponent {
    lang = ensureShareBasicI18n(inject(LanguageService));
    public title = this.lang.t('shareBasic.info');
    public text = ''
    constructor(public dialogRef: MatDialogRef<DialogInfoComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { title: string, text: string, onDelete: Function, onCancel: Function },
                public api: JApiService) {
        dialogRef.disableClose = true;

        if (data.text)
            this.text = data.text;

        if (data.title)
            this.title = data.title;
    }

    public onCancel() {
        this.dialogRef.close();
    }

}
